/* tslint:disable */
/* eslint-disable */
export enum WorkUseremploymentSalaryIntervalEnum {
  Months12 = 'MONTHS12',
  Months13 = 'MONTHS13'
}
